import { render, staticRenderFns } from "./AllContacts.vue?vue&type=template&id=ff41a07e&"
import script from "./AllContacts.vue?vue&type=script&lang=js&"
export * from "./AllContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports